<template>
  <SubContent @back="$router.go(-1)">
    <template v-slot:nav_left>
      全部比赛报告
    </template>
    <template v-slot:content_right>
      <div class="mainTrainingContent">
        <yioks-loading v-if="loading"></yioks-loading>
        <template v-else>
          <yioks-empty v-if="empty" />
          <div   v-else class="train_list_wrap" >
            <div  class="table">
              <div class="thead">
                <div class="tr">
                  <div class="th name"><strong>比赛名称</strong></div>
                  <div class="th coachName"><strong>比赛性质</strong></div>
                  <div class="th startTime"><strong>开始时间</strong></div>
                  <div class="th position"><strong>比赛时长</strong></div>
                </div>
              </div>
              <div class="scrollArea">
                <vue-scroll >
                  <div class="tbodyWrap">
                    <div class="tbody">
                      <div
                          v-for="(item, index) in mediaList"
                          :key="index"
                          class="tr">
                        <div class="trH">
                          <div class="td name">
                            <p>{{ item.matchName || '--' }}</p>
                          </div>
                          <div class="td coachName">
                            <p>{{item.matchType || '--'}}</p>
                          </div>
                          <div class="td startTime">
                            <p>{{ item.matchTime | time  }}</p>
                          </div>
                          <div class="td position">
                            <p>{{parseInt(item.matchTotalTime / 60)}} 小时 {{item.matchTotalTime % 60}} 分钟</p>
                          </div>
                        </div>
                        <div class="info">
                          <div class="score rowLine">
                            <p style="display: flex;justify-content: space-between;width: 100%;padding: 0 15px">
                              <span>上场是时间：{{parseInt(item.attendanceTime / 60)}} 小时 {{item.attendanceTime % 60}} 分钟</span>
                              <span>比赛结果：{{ item.matchResult }}（{{item.totalGoalScore}}：{{item.totalGoalConceded}}）</span>
                              <span>进球数： {{item.goalScore}}</span>
                              <span>助攻数： {{item.goalAssisted}}</span>
                            </p>
                          </div>
                          <div class="score rowLine">
                            <p style="display: flex;justify-content: space-between;width: 100%;padding: 0 15px">
                              <span>比赛对手：{{item.vs || '--'}}</span>
                              <span>主要阵型： {{item.teamFormation || '--'}}</span>
                              <span>比赛地点： {{item.matchPlace || '--'}}</span>
                              <span>比赛天气： {{item.weather || '--'}}</span>
                            </p>
                          </div>
                          <div class="time rowLine">
                            比赛总结：<span v-html="item.matchSummary"></span>
                          </div>
                          <div class="comment rowLine">
                            <p>球员总体评价：{{item.generalEvalComments || '--'}}</p>
                          </div>
                          <div class="score rowLine">
                            <p style="display: flex;justify-content: space-between;width: 100%;padding: 0 15px">
                              <span > 技术评价： {{item.technicalScore || '--'}}</span>
                            </p>
                          </div>
                          <div class="score rowLine">
                            <p style="display: flex;justify-content: space-between;width: 100%;padding: 0 15px">
                              <span> 战术评价： {{item.tacticalScore || '--'}}</span>
                            </p>
                          </div>
                          <div class="score rowLine">
                            <p style="display: flex;justify-content: space-between;width: 100%;padding: 0 15px">
                              <span> 体能评价： {{item.physicalScore || '--'}}</span>
                            </p>
                          </div>
                          <div class="score rowLine">
                            <p style="display: flex;justify-content: space-between;width: 100%;padding: 0 15px">
                              <span> 心智评价： {{item.psychologicalScore || '--'}}</span>
                            </p>
                          </div>
                          <div class="score rowLine">
                            <p style="display: flex;justify-content: space-between;width: 100%;padding: 0 15px">
                              <span> 社交评价： {{item.overallScore || '--'}}</span>
                            </p>
                          </div>
                          <div class="goals rowLine">
                            <p>建议：{{item.learningObjectives || '--'}}</p>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </vue-scroll>
              </div>
            </div>
          </div>
        </template>
      </div>
      <Pagination :total="total" :page.sync="page"/>
    </template>
  </SubContent>
</template>

<script>
import match from '@/api/match'
import playImg from '@/assets/images/common/playImg.png'
import planImg from '@/assets/images/common/plan_default.png'
export default {
  name: 'More',
  components: {
    'SubContent': () => import('@/components/layout/list'),
    'Pagination': () => import('@/components/Pagination')
  },
  data () {
    return {
      playImg,
      planImg,
      playerUuid: this.$route.query.uuid,
      mediaList: [],
      page: 0,
      pageSize: 20,
      total: 0,
      empty: false,
      loading: false,
    }
  },
  created () {
    this.getMediaList()
  },
  methods: {
    getMediaList () {
      this.loading = true
      match.getMatchReportListToPlayer({ page: this.page, size: this.pageSize, playerUuid: this.playerUuid }).then(res => {
        this.loading = false
        if (res.content.length === 0) {
          this.empty = true
        } else {
          this.empty = false
          this.total = res.totalElements
          this.mediaList = res.content
        }
      }).catch(err=>{
        this.loading = false
      })
    },
    filterTime (val) {
      if (val === 0) {
        return '00'
      }
      if (String(val).length < 2) {
        return '0' + String(val)
      } else {
        return val
      }
    },
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.mainTrainingContent
  height 570px
  .train_list_wrap
    margin-top 40px
    flex 1
    overflow hidden
    .table {
      display flex
      flex-direction column
      flex 1
      width: 100%;
      // margin: 30px 0 0;
      .thead {
        border: 1px solid $color_white;
        border-bottom  none
      }
      .thead {
        margin: 0 40px;
        .tr {
          height: 45px;
          display: flex;
        }
      }
      .scrollArea {
        height: 470px;
        padding-bottom 15px
        /*flex 1 */
        /*overflow hidden*/
      }
      .tbodyWrap {
        display block
        // padding: 0 40px;
      }
      .tbody {
        display block
        width 810px
        margin-left auto
        margin-right auto
        max-width: 810px;
        border-top: none;
        border-bottom: none;
        .tr{
          border  1px solid white
          margin-bottom 20px
        }
        .trH {
          height: 49px;
          display: flex;
          border-bottom: 1px solid $color_white;
          flex-wrap wrap
        }
        .info{
          .rowLine{
            min-height 49px
            display flex
            align-items center
            border-bottom 1px solid white
            &:last-child{
              border-bottom none
            }
          }
          .goals,.comment,.time {
            padding 5px 15px
          }
        }
      }
      .th, .td {
        height: 100%;
        /*flex: 1 1 auto;*/
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: $font_size_medium;
        border-right: 1px solid $color_white;
      }
      .th:last-child, .td:last-child {
        border-right: none;
      }
      .td {
        p {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          color: $color_white;
        }
      }
      .startTime{
        width 15%
      }
      .name{
        width 35%
      }
      .coachName{
        width: 20%;
      }
      .position{
        width: 30%
      }
    }
</style>
